/**
 * CUSTOM DESC
 * Descriptions of the answers written for one question (customDesc), one text per language.
 * Old questions have one single text without language (key without suffix) : it is the text of the first language
 * of the questionnaire, and the participants keep seeing it until a text is written for their language.
 */

//Keys of the descriptions of a question : the 5 levels of a likert scale (the middle one is hidden for 4 values),
//the two ends of the scale on 10, or the two answers of a Yes/No question (the keys read by the quickvote)
export function getCustomDescBases(responseCount: number): string[] {
  if (responseCount === 10) return ["question_nps_happy", "question_nps_unhappy"]
  if (responseCount === 2) return ["utils_no", "utils_yes"]
  return [1, 2, 3, 4, 5].filter((i) => !(responseCount === 4 && i === 3)).map((i) => "question_likert_" + i)
}

export function customDescKey(base: string, language: string): string {
  return base + "_" + language
}

//Text to display in the editor for a language
export function getCustomDesc(
  options: { [key: string]: any } | undefined,
  base: string,
  language: string,
  languages: string[]
): string {
  const own = options?.[customDescKey(base, language)]
  if (typeof own === "string") return own
  return language === languages[0] && typeof options?.[base] === "string" ? options[base] : ""
}

//Texts of the answers written for the whole questionnaire (allDesc, in the options of the template) : one text per language
//for each key of the scales with a custom text (key of the option : response<count>Label_<key>_<language>)
export const ALL_DESC_SCALES: { count: number; keys: string[] }[] = [
  { count: 5, keys: ["1", "2", "3", "4", "5"] },
  { count: 2, keys: ["yes", "no"] },
  { count: 10, keys: ["happy", "unhappy"] }
]

export function allDescKey(count: number, key: string, language: string): string {
  return "response" + count + "Label_" + key + "_" + language
}
